<h5 class="title-h5 text-center">{{ "public_lostpassword_title" | translate }}</h5>
<form class="mt-8" (ngSubmit)="lostPassword()">
    <input
        pInputText
        type="text"
        [formControl]="emailControl"
        class="w-full"
        placeholder="{{ 'public_lostpassword_email' | translate }}"
        appAutofocus
        [email]="true"
    />
    @if (submitSuccess) {
        <p-message class="mt-4 block" severity="success">{{ "public_lostpassword_success_inline" | translate }}</p-message>
    } @else {
        @if (emailControl.invalid && displayValidationMessages) {
            <div class="flex flex-col field p-fluid mt-3">
                @if (emailControl.errors?.["required"]) {
                    <p-message class="mb-1" severity="error">{{ "standard_email_required" | translate }}</p-message>
                } @else if (emailControl.errors?.["email"]) {
                    <p-message class="mb-1" severity="error">{{ "standard_email_validation_error" | translate }}</p-message>
                }
            </div>
        }
        @if (submitError) {
            <p-message class="mt-4 block" severity="error">{{ "public_lostpassword_resetnotsent" | translate }}</p-message>
        }
        <button pButton type="submit" class="body-button w-full p-button-blue-logo mt-8" [loading]="isLoading">
            {{ "public_lostpassword_button" | translate }}
        </button>
    }
</form>
<div class="mt-16 body-small text-center">
    <p>
        {{ "public_lostpassword_back" | translate }}
        <a class="text-blue-logo" routerLink="/login">{{ "public_lostpassword_login" | translate }}</a>
    </p>
</div>
